import type { HomeBlock } from "@/lib/api";

export function isSystemBlock(block: Pick<HomeBlock, "source">): boolean {
  return block.source === "system";
}
